import {ExceptionHandlerService} from '../../services/exception-handler-service';
import {Injectable} from '@angular/core';
import {Exception} from '../exception';
import {DialogService} from '../../services/dialog.service';
import {AuthService} from '../../services/auth.service';

@Injectable()
export class FallbackExceptionHandler extends ExceptionHandlerService {

  constructor(private readonly dialogService: DialogService, private readonly authService: AuthService) {
    super();
  }

  handle(exception: Exception) {
    this.dialogService.openExceptionDialog({
      data: {
        title: exception.clientException?.clientSubject ?? 'exceptions.fallback.modal.subject',
        message: exception.clientException?.clientBody ?? 'exceptions.fallback.modal.body',
      }
    }).afterClosed().subscribe(() => {
      this.authService.logout();
    });
  }

  isResponsible(): boolean {
    return false;
  }
}
